<template>
  <div id="app" v-cloak>
    <!-- Loading overlay con spinner -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <!-- Contenido principal -->
    <div v-else>
      <router-view />

      <!-- Íconos flotantes en la esquina inferior izquierda -->
      <div class="socials-bottom-left">
         <!-- WhatsApp -->
        <a
          href="https://wa.me/584143516746?text=Hola%2C%20quiero%20comenzar%20mi%20transformaci%C3%B3n%20en%20Victoria%20Gym%20💪"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon whatsapp"
          aria-label="WhatsApp Victoria Fitness Center"
        >
          <i class="bi bi-whatsapp"></i>
        </a>
        <!-- Instagram -->
        <a
          href="https://www.instagram.com/victoriafitnesscenter/?hl=es"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon instagram"
          aria-label="Instagram Victoria Fitness Center"
        >
          <i class="bi bi-instagram"></i>
        </a>

       

        <!-- TikTok -->
        <a
          href="https://www.tiktok.com/@victoriafitnesscenterca?_t=ZM-8zkvMAkZ5QT&_r=1"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon tiktok"
          aria-label="TikTok Victoria Fitness Center"
        >
          <i class="bi bi-tiktok"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const loading = ref(true)

onMounted(() => {
  setTimeout(() => {
    loading.value = false
  }, 1500)
})
</script>

<style scoped>
@import "bootstrap-icons/font/bootstrap-icons.css";

/* Reset y adaptación del body y html */
html, body, #app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #1a1a1a;
  color: #fff;
}

/* Esconder contenido hasta que Vue monte */
[v-cloak] { display: none; }

/* Loading overlay a pantalla completa */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #1a1a1a;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* Spinner circular */
.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #ffd700;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Contenedor flotante */
.socials-bottom-left {
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 1000;
}

/* Íconos flotantes */
.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 2rem;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  touch-action: manipulation;
  text-decoration: none;
}

/* Instagram */
.social-icon.instagram {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
}
.social-icon.instagram:hover,
.social-icon.instagram:active {
  transform: scale(1.2);
  box-shadow: 0 0 15px rgba(220,35,102,0.7);
}

/* WhatsApp */
.social-icon.whatsapp {
  background-color: #25D366;
}
.social-icon.whatsapp:hover,
.social-icon.whatsapp:active {
  transform: scale(1.2);
  box-shadow: 0 0 15px rgba(37,211,102,0.7);
}

/* TikTok */
.social-icon.tiktok {
  background-color: #000;
}
.social-icon.tiktok:hover,
.social-icon.tiktok:active {
  transform: scale(1.2);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
}

/* Responsive */
@media (max-width: 768px) {
  .social-icon { width: 50px; height: 50px; font-size: 1.8rem; }
}

@media (max-width: 480px) {
  .socials-bottom-left { bottom: 60px; gap: 0.7rem; }
  .social-icon { width: 45px; height: 45px; font-size: 1.5rem; }
}
</style>
